import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-bounds",
    templateUrl: "./go-bounds.component.html"
})


export class GoBoundsComponent extends GoBaseComponent {
    UI_TEXTS = UI_TEXTS;


    constructor() {
        super(GO_COMPONENTS.BOUNDS);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-bounds/go-bounds.component.ts